import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useHistory, Link } from 'react-router-dom'
import { ChevronLeftIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { HOME, CASELESS_CHECKOUT } from '../../routing/paths'
import StoreContext from '../../providers/storesContext'
import Button from '../../components/Button'
import SelectableCitations from '../../components/SelectableCitations'

const CaselessDetail = () => {
  const history = useHistory()
  const { licenseStore } = useContext(StoreContext)

  const { license } = licenseStore

  const handleCheckout = async () => {
    const result = await licenseStore.proceedToCheckout()
    if (result) {
      history.push(CASELESS_CHECKOUT)
    } else {
      console.log('Something went wrong :(')
    }
  }

  useEffect(() => {
    if (!license) {
      history.push(HOME)
    } else {
      topBarStore.setTitle(`License # ${license.number} - ${license.state}`)
      topBarStore.setActionIcon(
        <button onClick={()=> history.goBack()}>
          <ChevronLeftIcon className="h-6 w-6" />
        </button>
      )
    }
    return () => topBarStore.reset()
  }, [])

  if (!license) {
    return null
  }

  return (
    <div className="flex flex-col flex-1">
      <SelectableCitations />
      <div className="mt-auto mb-8">
        <Button extraStyle="w-full transition-all" onClick={handleCheckout}>
          Check out
        </Button>
      </div>
    </div>
  )
}

export default observer(CaselessDetail)
